import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import BrowsersOSPieChart from "./BrowsersOSPieChart";
import BrowsersTypePieChart from "./BrowsersTypePieChart";
import BrowsersSystemPieChart from "./BrowsersSystemPieChart";
import BrowsersCityPieChart from "./BrowsersCityPieChart";
import BrowsersRegionPieChart from "./BrowsersRegionPieChart";
import BrowsersCountryPieChart from "./BrowsersCountryPieChart";
import constantsReportCampaign from "./constants/reportCampaign";
import reportAction from "../../../store/actions/reportCampaignAction";

function BrowserData({
  campaignTypeCategorySelected,
  isGetDataBrowserCitiesFromApi,
  isGetDataBrowserTypeFromApi,
  dateFrom,
  dateTo,
  campaignIDSelected,
  whichTypeSelect,
  getCampaignReportBrowserCities,
  getCampaignsReportBrowserCities,
  getCampaignReportBrowserData,
  getCampaignsReportBrowserData,
}) {
  const [showLoaderBrowserCities, setShowLoaderBrowserCities] = useState(0);
  const [showLoaderBrowseData, setShowLoaderBrowseData] = useState(0);

  useEffect(() => {
    if (!isGetDataBrowserCitiesFromApi) {
      setShowLoaderBrowserCities(0);
    }
  }, [isGetDataBrowserCitiesFromApi]);

  useEffect(() => {
    if (!isGetDataBrowserTypeFromApi) {
      setShowLoaderBrowseData(0);
    }
  }, [isGetDataBrowserTypeFromApi]);

  const generateBrowsersCityPieChart = () => {
    return (
      <div className="d-flex flex-column flex-lg-row justify-content-lg-around pb-2">
        <BrowsersCityPieChart />
        <BrowsersRegionPieChart />
        <BrowsersCountryPieChart />
      </div>
    );
  };

  const generateBrowsersDataPieChart = () => {
    return (
      <div className="d-flex flex-column flex-lg-row justify-content-lg-around pb-2">
        <BrowsersTypePieChart />
        <BrowsersOSPieChart />
        <BrowsersSystemPieChart />
      </div>
    );
  };

  const generateLoader = () => {
    return (
      <>
        <div className="px-2">
          <div className="alert alert-warning  w-100">
            <p className="text-center m-0">
              {" "}
              این گزارش ممکن است چند ثانیه طول بکشد
            </p>
          </div>
        </div>
        <div className="d-flex justify-content-center align-items-center py-2">
          <img src="/assets/img/hilite.gif" />
        </div>
      </>
    );
  };

  const getReportCampaignLocationBrowser = () => {
    setShowLoaderBrowserCities(1);
    if (whichTypeSelect == constantsReportCampaign.whichTypeSelect.CAMPAIGN) {
      getCampaignReportBrowserCities({
        campaign_id: campaignIDSelected,
        date_from: dateFrom,
        date_to: dateTo,
      });
    } else if (
      whichTypeSelect == constantsReportCampaign.whichTypeSelect.TYPE_CAMPAIGNS
    ) {
      getCampaignsReportBrowserCities({
        date_from: dateFrom,
        date_to: dateTo,
      });
    }
  };

  const getReportCampaignBrowserInfo = () => {
    setShowLoaderBrowseData(1);
    if (whichTypeSelect == constantsReportCampaign.whichTypeSelect.CAMPAIGN) {
      getCampaignReportBrowserData({
        campaign_id: campaignIDSelected,
        date_from: dateFrom,
        date_to: dateTo,
      });
    } else if (
      whichTypeSelect == constantsReportCampaign.whichTypeSelect.TYPE_CAMPAIGNS
    ) {
      getCampaignsReportBrowserData({
        campaign_type: campaignTypeCategorySelected,
        date_from: dateFrom,
        date_to: dateTo,
      });
    }
  };

  const generateButtonGetBrowsersCitiesChart = () => {
    return (
      <>
        <div className="py-2 px-2">
          <span
            className="btn btn-success"
            onClick={getReportCampaignLocationBrowser}
          >
            نمایش گزارش شهر , کشور و استان
          </span>
        </div>
        {showLoaderBrowserCities ? generateLoader() : <></>}
      </>
    );
  };

  const generateButtonGetBrowsersDataChart = () => {
    return (
      <>
        <div className="py-2 px-2">
          <span
            className="btn btn-success"
            onClick={getReportCampaignBrowserInfo}
          >
            نمایش گزارش اطلاعات مرورگر
          </span>
        </div>
        {showLoaderBrowseData ? generateLoader() : <></>}
      </>
    );
  };

  return (
    <>
      {isGetDataBrowserCitiesFromApi
        ? generateBrowsersCityPieChart()
        : generateButtonGetBrowsersCitiesChart()}

      {isGetDataBrowserTypeFromApi
        ? generateBrowsersDataPieChart()
        : generateButtonGetBrowsersDataChart()}
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    isGetDataBrowserCitiesFromApi:
      state.reportCampaign.is_get_data_browser_cities_from_api,
    campaignTypeCategorySelected:
      state.reportCampaign.campaign_type_category_selected,
    isGetDataBrowserTypeFromApi:
      state.reportCampaign.is_get_data_browser_type_from_api,
    dateFrom: state.reportCampaign.date_from,
    dateTo: state.reportCampaign.date_to,
    campaignIDSelected: state.reportCampaign.campaign_id_selected,
    whichTypeSelect: state.reportCampaign.which_type_select,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getCampaignsReportBrowserCities: (action) => {
      dispatch({
        type: reportAction.GET_CAMPAIGNS_REPORT_BROWSER_CITIES,
        payload: action,
      });
    },
    getCampaignReportBrowserCities: (action) => {
      dispatch({
        type: reportAction.GET_CAMPAIGN_REPORT_BROWSER_CITIES,
        payload: action,
      });
    },
    getCampaignReportBrowserData: (action) => {
      dispatch({
        type: reportAction.GET_CAMPAIGN_REPORT_BROWSER,
        payload: action,
      });
    },
    getCampaignsReportBrowserData: (action) => {
      dispatch({
        type: reportAction.GET_CAMPAIGNS_REPORT_BROWSER,
        payload: action,
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BrowserData);
